import { Component } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { MissionComponent } from '../../sections/mission/mission.component';
import { ValuesComponent } from '../../sections/values/values.component';
@Component({
  selector: 'app-about',
  standalone: true,
  imports: [HeaderComponent,MissionComponent,ValuesComponent],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent {
  constructor() {
    document.body.style.backgroundColor = '#fff';
  }
}
